<script>
	import Swiper from "./Swiper.svelte";

	let slides = [
		{
			id: 1,
			image: "/photo/IMG_16.jpg",
		},
		{
			id: 2,
			image: "/photo/IMG_17.jpg",
		},
		{
			id: 3,
			image: "/photo/IMG_18.jpg",
		},
		{
			id: 4,
			image: "/photo/IMG_19.jpg",
		},
		{
			if: 5,
			image: "/photo/IMG_20.jpg",
		},
	];

	let expParams = {
		buttonText: "ОСТАЛЬНЫЕ ОТЗЫВЫ",
		buttonLink: "https://t.me/+q2k_jqXtOSVkNTVi",
	};
</script>

<div class="module4">
	<div class="text">
		<p class="t1">ОТЗЫВЫ</p>
	</div>
</div>

<Swiper {slides} , {expParams} />

<style>
	.module4 {
		width: fit-content;
		margin: 0 auto;
		/* margin-top: -50px; */
		position: relative;
	}

	.text {
		width: 100%;
		text-align: center;
	}

	.t1 {
		color: #4f7942;
		/* text-align: center; */
		font-size: 30px; /*Размер шрифта*/
		font-weight: 600; /*Толщина*/
	}

	@media (min-width: 1200px) {
		.module4 {
			width: 50%;
			margin-bottom: 20px;
		}
		.t1 {
			margin-bottom: 10px;
		}
	}
	@media (max-width: 480px) {
		.module4 {
			width: 90%;
			/* margin-bottom: 25px; */
		}
		.t1{
			margin: 40px 0px 5px 0px;
		}
	}
	@media (min-width: 481px) and (max-width: 960px) {
        .module4 {
			width: 90%;
			/* margin-bottom: 25px; */
		}
		.t1{
			margin: 40px 0px 5px 0px;
		}
    }
	@media (min-width: 961px) and (max-width: 1199px) {
        .module4 {
			width: 90%;
			/* margin-bottom: 25px; */
		}
		.t1{
			margin: 80px 0px 25px 0px;
		}
    }
</style>
